// Improtant!!! this file use old rendition table-directive.js but interaction should be added in future!
import React, {PureComponent} from 'react';
import {isUndefined, isEmpty, isEqual} from 'lodash';
import $ from 'jquery';
import {IReducerState} from '../states/renditionStates';
import {connect} from 'react-redux';
import UserAgentUtils from '../utils/general/userAgentUtils';
import * as HTML_RENDITION from '../utils/general/general';
import StyleTransfrom from '../utils/general/styleTransform';
import DomTemplate from './domTemplate';
import shortid from 'shortid';
import * as environmentService from '../utils/general/environmentService';
import FigureGalleryDom from '../mainpage/figureGallery';
import servicesConfig from '../services/servicesConfig';
import {fetchFigureGallery, fetchFPFigureGallery} from '../actions/asyncStateAction';
import {RSCH_HTML_TRACKING_CONFIG} from '../readership/trackingConfig';
import * as deviceInfoService from '../utils/general/deviceInfoService';
import ModalPopup from '../modalrelated/modalPopup';
import FullScreenPopup from '../modalrelated/fullScreenPopup';
import NormalScreenPopup from '../modalrelated/normalScreenPopup';
import ErrorBoundary from '../utils/api/errorBoundary';
import { enterKeyPressed } from '../utils/general/enterKey';
import { isFigureGalleryPopup } from '../utils/general/general';

interface ICitiTableTemplateType {
    isDataSummary?: boolean;
    isEarningEstimate?: boolean;
    isFigureGalleryTable?: boolean;
}

interface ICitiTableTemplateProperty {
    source: any;
    docHeaderSectionJson: any;
    initialData: any;
    figureGalleryData: any;
    adaText?: any;
    anchorValue?: string;
    showCopyFigure?: boolean;
    loadFigureGalleryData: () => {};
}
interface ICitiTableTemplateProps extends ICitiTableTemplateType, ICitiTableTemplateProperty {
    // Combine interfaces
}

interface ICitiTableTemplateState {
    tableElement: any;
    modalStatus: boolean; // Improtant!!! each modal should have a unique status! don't use redux in this value!
    modalTitle: any;
    modalSource: any;
}

export class CitiTableTemplate extends PureComponent<ICitiTableTemplateProps, ICitiTableTemplateState> {
    public tableId: any = '';

    constructor(props: ICitiTableTemplateProps) {
        super(props);
        this.state = {
            tableElement: null,
            modalStatus: false,
            modalTitle: null,
            modalSource: null,
        };
    }

    public componentDidMount() {
        if (window.HTML_RENDITION.initialData.isStaticHtml){
            return;
        }
        this.buildTable();
    }

    public componentDidUpdate(){
        this.implementADAForTable(this.props.source.id);
    }

    public implementADAForTable (tableId: string) {
        const $table = $(`#${tableId}`);
        const captions = $table.find('.has_caption .CIRCaption');
        if ($table.hasClass('image-table')) {
            return;
        }
        let _caption = '';
        let _source = '';
        let ADAText = '';
        if (captions.length == 0 && $table.parents('table')) {
            const $parentTableWrapper = $table.parents('table');
            const tableCaption = $parentTableWrapper.find('.has_caption span.CIRCaption');
            const tableSource = $parentTableWrapper.find('.has_source span.CIRSourceNote');
            const tables = $parentTableWrapper.find('table');
            // Per chart
            if (tables.length == tableCaption.length) {
                for (let i = 0; i < tables.length; i++) {
                    _caption = tableCaption.eq(i).text();
                    _source = tableSource.eq(i).text();
                    ADAText = HTML_RENDITION.buildAdaAltText(_caption, _source);
                    tables.eq(i).attr('aria-label', ADAText);
                }
                if (tables.length > 1) {
                    $parentTableWrapper.addClass('side-by-side-per-chart');
                }
                return;
            }
            // Side-By-Side All
            if (tables.length > 1 && tableCaption.length == 1) {
                _caption = tableCaption.text();
                _source = tableSource.text();
                ADAText = HTML_RENDITION.buildAdaAltText(_caption, _source);
                for (let i = 0; i < tables.length; i++) {
                    tables.eq(i).attr('aria-label', ADAText);
                }
                $parentTableWrapper.addClass('side-by-side-all');
                return;
            }
            // Side-By-Side Per row
            if (tables.length > 1 && tables.length > tableCaption.length) {
                const TrHasTable = $parentTableWrapper.find('tr.has_table');
                for (let i = 0; i < TrHasTable.length; i++) {
                    _caption = tableCaption.eq(i).text();
                    _source = tableSource.eq(i).text();
                    ADAText = HTML_RENDITION.buildAdaAltText(_caption, _source);
                    const innerTable = TrHasTable.eq(i).find('table');
                    innerTable.attr('aria-label', ADAText);
                }
                $parentTableWrapper.addClass('side-by-side-per-row');
                return;
            }
        }
    }

    public buildTable() {
        if (this.props.source) {
            // Create the basic table.
            this.props.source.classes = "";
            this.props.source.attributes = "";

            let id = "";
            if (this.props.source.metadata && this.props.source.metadata.id) {
                id = 'id="' + this.props.source.metadata.id + '" ';
            }

            const tableID = !isUndefined(this.props.source.id) ? this.props.source.id : 'table_' + ('' + crypto.getRandomValues(new Uint32Array(1))[0]);

            const style = this.getStyleAsObject(this.props.source.format);
            const styleWithoutWidth = $.extend({}, style);
            let tableStyle: any = null;
            if (style.width) {
                delete styleWithoutWidth.width;
            }
            let tableStyleName = ' ';
            const isMobilePhone = UserAgentUtils.isMobile.any();
            if (this.props.source.isImageTable) {
                tableStyle = styleWithoutWidth;
            } else if ($("#citiTableCom").parents('#earningEstimates').length) {
                tableStyle = style;
            } else if (!this.props.isDataSummary && !this.props.isEarningEstimate
                    && this.props.source?.format?.class?.split(' ').indexOf('BodyTable') < 0
                    && this.props.source?.format?.class?.split(' ').indexOf('InBody') < 0) {
                tableStyleName = 'hundred_percent ';
                tableStyle = style;
            } else if (HTML_RENDITION.parseToBoolean(this.props.initialData.enable_table_width_percent) && !isMobilePhone) {
                tableStyleName = 'hundred_percent ';
                tableStyle = style;
            } else {
                tableStyle = style;
            }

            if (this.props.source.isInfographicImage) {
                tableStyleName += ' infographic-img-table ';
            }
            if (this.props.source.isDataTable) {
                tableStyleName += ' data-table ';
            }
            if (this.props.isDataSummary) {
                tableStyleName += ' data-summary-table ';
            }

            let isCatalystWatchTable = false;

            if (this.props.source.format?.class?.indexOf('CatalystWatch') > -1) {
                isCatalystWatchTable = true;
            }

            let rowIndex: number = 0;
            if (!isUndefined(this.props.source.rowStartIndex)) {
                rowIndex = parseInt(this.props.source.rowStartIndex, 10);
            }
            let tableElement = null;
            // Iterate the rows and cells.
            const trElement = [];
            let tableTitle = '';
            let tableSource = '';
            let contentTdForEachTrCount = 0;
            let contentTdForFGTargetInTable = 0;
            let sideBySideFlg = false;
            let captionCount = 0;
            for (; rowIndex < this.props.source.rows.length; rowIndex++) {
                const row = this.props.source.rows[rowIndex];
                let cellIndex = 0;
                const tdElement = [];
                let tr_cls;
                contentTdForEachTrCount = 0;
                for (cellIndex = 0; cellIndex < row.cells.length; cellIndex++) {
                    const cell = row.cells[cellIndex];
                    let hiddenButtonFlag = false;
                    // let hiddenButtonLabelText = '';
                    const cellDivElement = [];
                    cellDivElement.push(<DomTemplate sourceM={cell} dataStringM={'paragraph'} classNameM={''}
                                                     key={shortid.generate()} showOriginalText={true}/>);

                    const tempStyleObj = this.getStyleAsObject(cell.format);
                    let tempStyleObjWithoutWidth = $.extend({}, tempStyleObj);
                    if (tempStyleObj.width) {
                        delete tempStyleObjWithoutWidth.width;
                    }

                    let separatorFlag = false;
                    if (this.props.source.isImageTable &&
                        (row.cells.length == 3 || row.cells.length == 5) &&
                        !(JSON.stringify(cellDivElement).indexOf('"text"') > 0)) {
                        // JSON.stringify(cellDivElement).indexOf('"img"') > 0 is always false because drawingTemplate not register now
                        separatorFlag = true;
                    }
                    if (JSON.stringify(cellDivElement).indexOf('"CIRCaption"') > 0 &&
                        JSON.stringify(cellDivElement).indexOf('Figure') > 0) {         // button added for ada users in FG
                        // const cellData = cell?.data[0]?.data;
                        // hiddenButtonLabelText = cellData?.length ? cellData[cellData?.length - 1]?.text : '';
                        hiddenButtonFlag = true;
                    }
                    if ((rowIndex + 1 == this.props.source.rows.length) &&
                        (cellIndex + 1 == row.cells.length) &&
                        (isCatalystWatchTable || this.props.isDataSummary || this.props.isEarningEstimate)) {  // button added for ada users in CW/data summary/earningEstimate table
                        hiddenButtonFlag = true;
                    }
                    let cellStyle = "cellStyle_" + rowIndex + "_" + cellIndex;
                    if (this.props.source.isImageTable) {
                        tempStyleObjWithoutWidth = this.applyWidthPercentage(tempStyleObjWithoutWidth, cellIndex, row.cells.length, separatorFlag, row.cells);
                        cellStyle = tempStyleObjWithoutWidth;
                    } else {
                        cellStyle = tempStyleObj;
                    }
                    // Add custom class for image table cell. If the table cell has content, add class "content_cell"
                    // If the table cell contains image, add class "content_img_cell"
                    // If the table cell contains table, add class "content_table_cell"
                    let cellClassForFigureGallery = '';
                    let content_flag = false;
                    const tdCellJsonString = JSON.stringify(cellDivElement);
                    if (tdCellJsonString.indexOf('"drawing"') > 0) {
                        cellClassForFigureGallery = 'content_cell content_img_cell fg_target_cell';
                        tr_cls = 'has_content';
                        content_flag = true;
                        contentTdForEachTrCount++;
                        contentTdForFGTargetInTable++;
                    } else if (tdCellJsonString.indexOf('"table"') > 0) {
                        cellClassForFigureGallery = 'content_cell content_table_cell fg_target_cell';
                        tr_cls = 'has_content has_table';
                        content_flag = true;
                        contentTdForEachTrCount++;
                        contentTdForFGTargetInTable++;
                    } else if (tdCellJsonString.indexOf('"text"') > 0) {
                        cellClassForFigureGallery = 'content_cell content_text_cell';
                        contentTdForEachTrCount++;
                    }
                    // Add class "no-trigger", need click any prat has this class, will not trigger FG open
                    // Confirmed with BA
                    // This is because when click any text cell in side-by-side table, need open its neighbor image.
                    // It is hard to figure out text cell and caption/source/footnote/sub caption.
                    if (tdCellJsonString.indexOf('"CIRCaption"') > 0 && tdCellJsonString.indexOf("\"class\":\"table\"") == -1) {
                        tr_cls = `has_caption ${this.props.source.isInfographicImage ? '' : 'no-trigger'}`;
                        content_flag = true;
                        tableTitle = cell?.data[0]?.data?.length ? cell?.data[0]?.data[cell?.data[0]?.data?.length - 1]?.text : '';
                        captionCount++;
                    }
                    if (tdCellJsonString.indexOf('"CIRSourceNote"') > 0) {
                        tr_cls = `has_source ${this.props.source.isInfographicImage ? '' : 'no-trigger'}`;
                        content_flag = true;
                        tableSource = cell?.data[0]?.data?.length ? cell?.data[0]?.data[cell?.data[0]?.data?.length - 1]?.text : '';
                    }
                    if (tdCellJsonString.indexOf('"CIRFootNote"') > 0) {
                        tr_cls = `has_footnote ${this.props.source.isInfographicImage ? '' : 'no-trigger'}`;
                        content_flag = true;
                    }
                    if (tdCellJsonString.indexOf('"CIRSubCaption"') > 0) {
                        tr_cls = `has_subcaption ${this.props.source.isInfographicImage ? '' : 'no-trigger'}`;
                        content_flag = true;
                    }

                    tdElement.push(
                        <td key={shortid.generate()} className={cellClassForFigureGallery + ' ' + this.getStyle(cell) + (hiddenButtonFlag ? ' hiddenButtonTd' : '')}
                            style={StyleTransfrom(cellStyle)} colSpan={this.getSpan(cell)}
                            rowSpan={this.getRowSpan(cell)}>
                            {cellDivElement}
                            {hiddenButtonFlag && (<button className="table_hidden_button"
                                onKeyPress={(e) => enterKeyPressed(e, this.pressHiddenButton.bind(this, e))}>View Details</button>)}
                            {/* aria-label={hiddenButtonLabelText} */}
                        </td>
                    );
                }
                if (contentTdForFGTargetInTable > 0 && contentTdForEachTrCount > 1) {
                    // Inculdes the scenario: side by side table only has one row with one FG target and one text cell.
                    sideBySideFlg = true;
                }
                const _style = isCatalystWatchTable ? null : this.getStyleAsObject(row.format);
                const trClass = `has_td_${tdElement.length} has_content_td_${contentTdForEachTrCount} ${row?.customClass}`;
                trElement.push(<tr key={shortid.generate()} className={`${this.getStyle(row)} ${trClass} ${tr_cls}`} style={_style}>
                        {tdElement}
                    </tr>);

            }
            let sideBySideClass = '';
            if (captionCount > 0 && sideBySideFlg) {
                sideBySideClass = 'sideBySide';
            }

            let ariaLabel = this.props.adaText;
            if (isEmpty(ariaLabel) ) {
                ariaLabel = HTML_RENDITION.buildAdaAltText(tableTitle, tableSource);
            }

            tableElement =
                <div id={this.getBBOrCWStyle(this.props.source)}
                     className={this.props.source.classes + ' ' + this.getStyle(this.props.source) + ' tableWrapper ' + this.isSideTable() + ' ' + this.isSideBySideTable() + ' ' + sideBySideClass + ' '  + (this.props.source.isInnerTable ? 'innerTable' : '')}
                     onClick={(e) => this.openEnlargedTable(e)}
                     onKeyPress={(e) => enterKeyPressed(e, this.openEnlargedTable.bind(this, e))}>
                    <table id={tableID}
                           aria-label={ariaLabel}
                           className={'x-rsch-table ' + tableStyleName + ' ' + this.getStyle(this.props.source) + ' ' + (this.props.source.isImageTable ? 'image-table' : '')}
                           style={StyleTransfrom(tableStyle)}>
                        <tbody>
                        {trElement}
                        </tbody>
                    </table>
                </div>;

            this.setState({
                tableElement
            });
        }
    }

    public pressHiddenButton(e: any) {
        const noTriggerTr = $(e.target).parents('tr').hasClass('no-trigger');
        $(e.target).addClass('triggered_popup_flag');
        // if the tr has the class of 'no-trigger', then the tr can't be triggered to popup FG modal; then we need to find the next tr which can be triggered
        if (noTriggerTr) {
            const isSideBySide = $(e.target).parents('.tableWrapper').hasClass('sideBySide');
            const buttonLength = $(e.target).parents('tr').find('.table_hidden_button').length;
            if (isSideBySide && buttonLength == 1) {
                const contentTr = $(e.target).parents('tr').nextAll('tr').filter(".has_content").first();
                if (contentTr.find('.content_table_cell').length) {
                    contentTr.find('.content_table_cell table').first().click();
                }
                if (contentTr.find('.content_img_cell').length) {
                    contentTr.find('.content_img_cell img').first().click();
                }
            } else if (isSideBySide && buttonLength == 2) {   // side-by-side per chart
                const index = $(e.target).parents('tr').find($(e.target).parents('td')).index();
                const targetTd = $(e.target).parents('tr').nextAll('tr').not(".no-trigger").first().find('td.fg_target_cell ').eq(index).first();
                if (targetTd.has('.content_table_cell')) {
                    targetTd.find('table').first().click();
                }
                if (targetTd.has('.content_img_cell')) {
                    targetTd.find('img').first().click();
                }
            } else {
                $(e.target).parents('tr').nextAll('tr').not(".no-trigger").first().click();
            }
        }
    }

    public getStyleAsObject(format: any) {
        const temp: any = {};
        if (format && format.style) {
            const style = format.style;
            const styleSplitArr = style.split(';');
            for (let i = 0; i < styleSplitArr.length; i++) {
                const styleSubSplitArr = styleSplitArr[i].split(':');
                if (styleSubSplitArr.length == 2) {
                    temp[styleSubSplitArr[0]] = styleSubSplitArr[1];
                }
            }
        }
        return temp;
    }

    public getBBOrCWStyle(data: any) {
        if (data && data.format) {
            if (!isUndefined(data.format.class)) {
                if (data.format.class === 'CIRTable BullBearPage' || data.format.class === 'CIRTableNoLines CatalystWatch') {
                    const tempArr = data.format.class.split(" ");
                    return 'body' + tempArr[1];
                }
            }
        }
        return shortid.generate();
    }

    public getStyle(data: any) {
        if (data && data.format) {
            if (!isUndefined(data.format.class)) {
                return data.format.class;
            }
        }
        return '';
    }

    public isSideTable() {
        if (this.props.source && this.props.source.format) {
            if (!isUndefined(this.props.source.format.class)) {
                if (this.props.source.format.class && this.props.source.format.class.indexOf('sideTable') != -1) {
                    return 'sideTable';
                } else {
                    return '';
                }
            }
        }
        return '';
    }

    public isSideBySideTable() {
        if (this.props.source && this.props.source.tblDescription) {
            if (this.props.source.tblDescription == "SideBySideBody" || this.props.source.tblDescription == "SideBySideFull") {
                return 'no-float sideBySide';
            } else {
                return '';
            }
        }
        return '';
    }

    public openEnlargedTable($event: any) {
        const currentTarget = $($event.currentTarget);
        const target = $($event.target);

        if ((target.parents('div#bodyBullBearPage').length) > 0) {
            RSCH_HTML_TRACKING_CONFIG.trackBBInBody();
        }
        if ((target.parents('div#bodyCatalystWatch').length) > 0) {
            RSCH_HTML_TRACKING_CONFIG.trackCWInBody();
        }

        if (target.hasClass('narratives')
            || currentTarget.hasClass('narratives')){
            $event.stopPropagation();
            return;
        }

        if (currentTarget.parents("div.word-statabs").length > 0 && currentTarget.parents(".modalWindow").length < 1){
            $('#rating-block-group-id').click();
            return;
        }

        if (target.hasClass('x-rsch-drawing')
            || HTML_RENDITION.isPresentation()
            || (this.props.initialData.isPopup && this.props.initialData.isPopup != 'null')
            || (target.parents(".story-section").length > 0)
            || (currentTarget.parents(".modalWindow").length > 0)
            || (currentTarget.parents("#figure-gallery").length > 0)
            || (currentTarget.parents(".figure-gallery-container").length > 0)
            || (currentTarget.parents(".group-ratingblock").length > 0)
            || (currentTarget.parents("#issuerPage-RatingBlock").length > 0)
            || target.hasClass('pageRef')
            || target.parents('tr').hasClass('no-trigger')) {
            return;
        }

        let tableId: any = currentTarget.find('table').attr('id');
        if (currentTarget.parents('div.tableWrapper').length > 0) {
            tableId = currentTarget.parents('table').attr('id');
        }

        this.tableId = tableId;

        if (typeof (window.HTML_RENDITION.figureGalleryTableIdArray) == 'undefined'
            || window.HTML_RENDITION.figureGalleryTableIdArray.length == 0) {
            window.HTML_RENDITION.figureGalleryTableIdArray = [];
            if (!this.props.figureGalleryData) {
                this.props.loadFigureGalleryData();
            }
            if (this.props.figureGalleryData && this.props.figureGalleryData.figureGallery){
                window.HTML_RENDITION.figureGalleryTableIdArray = this.pushScrollIdArray(this.props.figureGalleryData.figureGallery);
            }
        }
        this.openPopup($event, tableId);
    }

    public pushScrollIdArray(data : any){
        const tempArr = [];
        for (let i=0; i < data.length;i++){
            tempArr.push(data[i].scrollTo);
        }
        return tempArr;
    }

    public openPopup($event: any, tableId: any) {
        const currentTarget = $($event.currentTarget);
        const table = currentTarget.parents("div.tableWrapper");
        const isFigureGalleryTableId = window.HTML_RENDITION.figureGalleryTableIdArray.indexOf(tableId) > -1;
        if (!isFigureGalleryTableId) {
            this.openTableFullScreenPopup(currentTarget, table);
            return;
        }

        // Figure Gallery
        let _modalTitle = '';
        let _modalSource: any = null;
        let figureGalleryDom: any = null;
        if (isFigureGalleryTableId &&
                (currentTarget.find('table').length ||
                    currentTarget.find('.image-table').length)) {
            _modalTitle = this.props.docHeaderSectionJson.i18n.figure_gallery ? this.props.docHeaderSectionJson.i18n.figure_gallery : '';
            // When clicked target is table, chart or image
            let targetName = currentTarget.find('>table').attr('id');

            // When click target is side-by-side text cell
            const textCellTd = $($event.target).parents('.content_text_cell');
            if (currentTarget.hasClass('sideBySide') && textCellTd) {
                const ImageOrTableCellTd = textCellTd.siblings('.fg_target_cell').eq(0);
                if (ImageOrTableCellTd.hasClass('content_img_cell')) {
                    targetName = ImageOrTableCellTd?.find('img')?.attr('src')?.toLowerCase().split('images/')[1].split('?')[0];
                } else if (ImageOrTableCellTd.hasClass('content_table_cell')) {
                    targetName = ImageOrTableCellTd.find('table').attr('id');
                }

            }

            if (targetName) {
                figureGalleryDom = this.openFigureGallery(targetName);
            }
        }

        // Other table content
        const tableTpl: any = this.openOtherTablePopup(currentTarget, table);

        if (figureGalleryDom) {
            _modalSource = figureGalleryDom;
        } else if (tableTpl && currentTarget.find('.image-table').length === 0) {
            _modalSource = tableTpl.prop("outerHTML");
        } else {
            _modalSource = null;
        }

        window.HTML_RENDITION.openDetachURL = HTML_RENDITION.getDetachUrl("figureGallery", _modalTitle);
        this.setState({
            modalSource: _modalSource,
            modalTitle: _modalTitle
        });
    }

    public openFigureGallery(targetName: string) {
        if (isEmpty(this.props.figureGalleryData)) {
            this.props.loadFigureGalleryData();
        }
        return <ErrorBoundary><FigureGalleryDom targetName={targetName}/></ErrorBoundary>;
    }

    public openOtherTablePopup(currentTarget: any, table: any) {
        let tableTpl: any = null;
        if (table.attr('id') === 'bodyCatalystWatch') {
            tableTpl = currentTarget.clone();
        } else if (table.length === 0) {
            tableTpl = currentTarget.clone();
            tableTpl.find('table').removeClass("hundred_percent");
        } else {
            tableTpl = $(table[0]).clone();
            tableTpl.find('table').removeClass("hundred_percent");
        }

        return tableTpl;
    }

    public openTableFullScreenPopup(currentTarget: any, table: any) {
        let tableTpl = null;

        if (table.length === 0){
            tableTpl = currentTarget.clone();
        } else {
            tableTpl = $(table[0]).clone();
        }

        tableTpl.find('table').removeClass("hundred_percent");
        this.setState({
            modalSource: tableTpl.html()
        });
    }

    public applyWidthPercentage(tempStyleObj: any, cellIndex: number, cellsCount: number, separatorFlag: boolean, allCells: any) {
        if (this.props.initialData.productType === 'landscape') {
            return tempStyleObj;
        }
        let widthPercentage;
        if (cellsCount == 2) {
            widthPercentage = "50%";
        } else if (cellsCount == 3 && separatorFlag) {
            if (JSON.stringify(allCells[1])?.indexOf('"drawing"') > 0) {
                widthPercentage = "33.3%";
            } else {
                if (cellIndex == 0 || cellIndex == 2) {
                    widthPercentage = "49.5%";
                } else {
                    widthPercentage = "1%";
                }
            }
        } else if (cellsCount == 4) {
            if (!allCells[1]?.data[0]?.data?.length && !allCells[2]?.data[0]?.data?.length) {
                if (cellIndex == 1 || cellIndex == 2) {
                    widthPercentage = ".5%";
                } else {
                    widthPercentage = "49%";
                }
            } else if (!allCells[1]?.data[0]?.data?.length || !allCells[2]?.data[0]?.data?.length) {
                if (cellIndex == 1 && !allCells[1]?.data[0]?.data?.length) {
                    widthPercentage = ".5%";
                } else if (cellIndex == 2 && !allCells[2]?.data[0]?.data?.length) {
                    widthPercentage = ".5%";
                } else {
                    widthPercentage = "33%";
                }
            } else {
                widthPercentage = "25%";
            }
        } else if (cellsCount == 5) {
            if (!(allCells[1]?.data[0]?.data?.length || allCells[1]?.data[0]?.rows?.length) &&
                !(allCells[3]?.data[0]?.data?.length || allCells[3]?.data[0]?.rows?.length)) {
                if (cellIndex == 1 || cellIndex == 3) {
                    widthPercentage = "2%";
                } else {
                    widthPercentage = "32%";
                }
            } else {
                widthPercentage = "19.5%";
            }
        }

        if (widthPercentage) {
            $.extend(tempStyleObj, {
                width: widthPercentage
            });
        }

        return tempStyleObj;
    }

    public getSpan(cell: any) {
        if (cell.format && cell.format.colspan) {
            return cell.format.colspan;
        } else {
            return 1;
        }
    }

    public getRowSpan(cell: any) {
        if (cell.format && cell.format.rowspan) {
            return cell.format.rowspan;
        } else {
            return 1;
        }
    }

    public openModal(e: any) {

        const currentTarget = $(e.currentTarget);
        const target = $(e.target);

        if ((target.hasClass('x-rsch-drawing'))
            || (target.hasClass('citiTable-template-part'))
            || HTML_RENDITION.isPresentation()
            || (this.props.initialData.isPopup && this.props.initialData.isPopup != 'null')
            || (target.parents(".story-section").length > 0)
            || (currentTarget.parents(".modalWindow").length > 0)
            || (currentTarget.parents("#figure-gallery").length > 0)
            || (currentTarget.parents(".figure-gallery-container").length > 0)
            || (currentTarget.parents(".group-ratingblock").length > 0)
            || (currentTarget.parents("#issuerPage-RatingBlock").length > 0)
            || target.hasClass('pageRef')) {
            return;
        }

        if (e && e.stopPropagation) {
            e.stopPropagation();
        } else {
            e.cancelBubble = true;
        }

        // Important!!! the close modal action can through bubbling propagation to here, So that we can set the status again!
        // Improtant!!! you must setState in below if else to avoid cause reRender!
        if (e.target?.id === "modalClose" || e.target?.id === "figureGalleryScrollTo") { // Improtant!!! if you want close modal in more case only change this if
            this.setState({
                modalStatus: false,
            });
            $('.triggered_popup_flag').first().focus();
            $('.triggered_popup_flag').removeClass('triggered_popup_flag');
        } else if (this.state.modalStatus === false) { // Improtant!!! don't change this if in any case
            this.setState({
                modalStatus: true,
            });
            e.target.className += " triggered_popup_flag";
        }
    }

    public figureGalleryWindowStyle () {
        const initialStyle = {width: '1233px',  background: 'transparent', height: '850px', left: '25px', marginTop: '20px'};
        let finalStyle = {};
        let deviceScreenStyle = {};
        let height = '';
        let width = '';
        if (deviceInfoService.isDeviceScreenType()) {
            height = `${window.innerHeight - 85}px`;
            width = `${window.innerWidth}px`;
            deviceScreenStyle = {left: 0, top: '65px', zIndex: 1050, position: 'fixed', marginTop: 0, height, width};
        } else {
            const mainPageWidth = document.getElementById('mainPage')?.offsetWidth || 0;
            height = `${window.innerHeight - 105}px`;
            width = `${mainPageWidth - 45}px`;
            deviceScreenStyle = {top: 0, bottom: 0, position: 'relative', height, width};
        }
        finalStyle = {...initialStyle, ...deviceScreenStyle};
        return finalStyle;
    }

    public figureGalleryBodyStyle () {
        const initialStyle = { overflow: 'initial' };
        let finalStyle = {};
        let deviceScreenStyle = {};
        if (deviceInfoService.isDeviceScreenType()) {
            deviceScreenStyle = {height: `${window.innerHeight - 85 - 27}px`};
        } else {
            deviceScreenStyle = {height: `${window.innerHeight - 105 - 27}px`};
        }
        finalStyle = {...initialStyle, ...deviceScreenStyle};
        return finalStyle;
    }

    public renderForStaticHtml() {
        const _modalStatus = this.state.modalStatus;
        const _modalSource = this.state.modalSource;
        let tableElement = null;
        if (this.props.source) {
            // Create the basic table.
            this.props.source.classes = "";
            this.props.source.attributes = "";

            let id = "";
            if (this.props.source.metadata && this.props.source.metadata.id) {
                id = 'id="' + this.props.source.metadata.id + '" ';
            }

            const tableID = !isUndefined(this.props.source.id) ? this.props.source.id : 'table_' + ('' + crypto.getRandomValues(new Uint32Array(1))[0]);

            const style = this.getStyleAsObject(this.props.source.format);
            const styleWithoutWidth = $.extend({}, style);
            let tableStyle: any = null;
            if (style.width) {
                delete styleWithoutWidth.width;
            }
            let tableStyleName = ' ';
            const isMobilePhone = UserAgentUtils.isMobile.any();
            if (this.props.source.isImageTable) {
                tableStyle = styleWithoutWidth;
            } else if ($("#citiTableCom").parents('#earningEstimates').length) {
                tableStyle = style;
            } else if (!this.props.isDataSummary && !this.props.isEarningEstimate
                && this.props.source?.format?.class?.split(' ').indexOf('BodyTable') < 0
                && this.props.source?.format?.class?.split(' ').indexOf('InBody') < 0) {
                tableStyleName = 'hundred_percent ';
            } else if (HTML_RENDITION.parseToBoolean(this.props.initialData.enable_table_width_percent) && !isMobilePhone) {
                tableStyleName = 'hundred_percent ';
                tableStyle = style;
            } else {
                tableStyle = style;
            }

            if (this.props.source.isInfographicImage) {
                tableStyleName += ' infographic-img-table ';
            }
            if (this.props.source.isDataTable) {
                tableStyleName += ' data-table ';
            }
            if (this.props.isDataSummary) {
                tableStyleName += ' data-summary-table ';
            }

            let rowIndex: number = 0;
            if (!isUndefined(this.props.source.rowStartIndex)) {
                rowIndex = parseInt(this.props.source.rowStartIndex, 10);
            }

            // Iterate the rows and cells.
            const trElement = [];
            for (; rowIndex < this.props.source.rows.length; rowIndex++) {
                const row = this.props.source.rows[rowIndex];
                let cellIndex = 0;
                const tdElement = [];
                for (cellIndex = 0; cellIndex < row.cells.length; cellIndex++) {
                    const cell = row.cells[cellIndex];

                    const cellDivElement = [];

                    cellDivElement.push(<DomTemplate sourceM={cell} dataStringM={'paragraph'} classNameM={''}
                                                     key={shortid.generate()} showOriginalText={true}/>);

                    const tempStyleObj = this.getStyleAsObject(cell.format);
                    let tempStyleObjWithoutWidth = $.extend({}, tempStyleObj);
                    if (tempStyleObj.width) {
                        delete tempStyleObjWithoutWidth.width;
                }

                    let separatorFlag = false;
                    if (this.props.source.isImageTable &&
                        (row.cells.length == 3 || row.cells.length == 5)) {
                        // JSON.stringify(cellDivElement).indexOf('"img"') > 0 is always false because drawingTemplate not register now
                        separatorFlag = true;
                    }
                    let cellStyle = "cellStyle_" + rowIndex + "_" + cellIndex;
                    if (this.props.source.isImageTable) {
                        tempStyleObjWithoutWidth = this.applyWidthPercentage(tempStyleObjWithoutWidth, cellIndex, row.cells.length, separatorFlag, row.cells);
                        cellStyle = tempStyleObjWithoutWidth;
                    } else {
                        cellStyle = tempStyleObj;
                    }
                    // Add custom class for image table cell. If the table cell has content, add class "content_cell"
                    // If the table cell contains image, add class "content_img_cell"
                    // If the table cell contains table, add class "content_table_cell"
                    const cellClassForFigureGallery = '';

                    tdElement.push(
                        <td key={shortid.generate()} className={cellClassForFigureGallery + ' ' + this.getStyle(cell)}
                            style={StyleTransfrom(cellStyle)} colSpan={this.getSpan(cell)}
                            rowSpan={this.getRowSpan(cell)}>
                            {cellDivElement}
                        </td>
                    );
                }

                const trClass = `has_td_${tdElement.length}`;

                trElement.push(
                    <tr key={shortid.generate()} className={`${this.getStyle(row)} ${trClass}`}>
                        {tdElement}
                    </tr>);
            }

            tableElement =
                <div id={this.getBBOrCWStyle(this.props.source)}
                        className={this.props.source.classes + ' ' + this.getStyle(this.props.source) + ' tableWrapper ' + this.isSideTable() + ' ' + this.isSideBySideTable() + ' ' + (this.props.source.isInnerTable ? 'innerTable' : '')}
                        onClick={(e) => this.openEnlargedTable(e)}
                        onKeyPress={(e) => enterKeyPressed(e, this.openEnlargedTable.bind(this, e))}>
                    <table role="table"  id={tableID}
                            className={'x-rsch-table ' + tableStyleName + ' ' + this.getStyle(this.props.source) + ' ' + (this.props.source.isImageTable ? 'image-table' : '')}
                            style={StyleTransfrom(tableStyle)}>
                        <tbody>
                        {trElement}
                        </tbody>
                    </table>
                </div>;
        }
        return (
            <div className="citiTable-template-part" onClick={(e) => this.openModal(e)}
                 onKeyPress={(e) => enterKeyPressed(e, this.openModal.bind(this, e))}>
                {_modalStatus && _modalSource && !this.state.modalTitle &&
                <ModalPopup>
                    <FullScreenPopup bodySource={_modalSource} showCopy={this.props.showCopyFigure} anchorValue={this.props.anchorValue} />
                </ModalPopup>}
                {_modalStatus && _modalSource && this.state.modalTitle &&
                <ModalPopup classList={"modal-gallery"}>
                    <NormalScreenPopup
                        titleSource={this.state.modalTitle}
                        bodySource={_modalSource}
                        modalBodyStyle={this.figureGalleryBodyStyle()}
                        modalWindowStyle={this.figureGalleryWindowStyle()}
                        openDetachURL={'true'}
                        showCopy={isFigureGalleryPopup(this.state.modalTitle, this.props.docHeaderSectionJson.i18n.figure_gallery) || this.props.showCopyFigure}
                        anchorValue={this.props.anchorValue}
                    />
                </ModalPopup>}
                {tableElement}
            </div>
        );
    }

    public render() {
        const _modalStatus = this.state.modalStatus;
        const _modalSource = this.state.modalSource;

        if (window.HTML_RENDITION.initialData.isStaticHtml){
            return this.renderForStaticHtml();
        } else {
            return (
                <div className="citiTable-template-part" onClick={(e) => this.openModal(e)}
                     onKeyPress={(e) => enterKeyPressed(e, this.openModal.bind(this, e))}>
                    {_modalStatus && _modalSource && !this.state.modalTitle &&
                    <ModalPopup>
                        <FullScreenPopup bodySource={_modalSource} showCopy={this.props.showCopyFigure} anchorValue={this.props.anchorValue} />
                    </ModalPopup>}
                    {_modalStatus && _modalSource && this.state.modalTitle &&
                    <ModalPopup classList={"modal-gallery"}>
                        <NormalScreenPopup
                            titleSource={this.state.modalTitle}
                            bodySource={_modalSource}
                            modalBodyStyle={this.figureGalleryBodyStyle()}
                            modalWindowStyle={this.figureGalleryWindowStyle()}
                            openDetachURL={'true'}
                            showCopy={isFigureGalleryPopup(this.state.modalTitle, this.props.docHeaderSectionJson.i18n.figure_gallery) || this.props.showCopyFigure}
                            anchorValue={this.props.anchorValue}
                        />
                    </ModalPopup>}
                    {this.state.tableElement}
                </div>
            );
        }
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        docHeaderSectionJson: state.asyncStateReducer.docHeaderJsonData,
        initialData: state.asyncStateReducer.initialData,
        figureGalleryData: state.asyncStateReducer.figureGalleryData,
    };
};

const mapDispatchToProps = (dispatch: (any)) => ({
    loadFigureGalleryData: () => dispatch(fetchFigureGallery(environmentService.getJsonPath(servicesConfig.GET_FIGURE_GALLERY))),
    loadFPFigureGalleryData: () => dispatch(fetchFPFigureGallery(environmentService.getJsonPath(servicesConfig.GET_FP_FIGURE_GALLERY))),
});

export default connect(mapStateToProps, mapDispatchToProps)(CitiTableTemplate);
